import React from "react";
import { Container } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import { Col } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import { Link } from "react-router-dom";
import "../../App.css";

function AgreeServicess() {
  return (
    <>
      <Container fluid>
        <Row className="p-5">
          <Col lg={12} className="pt-5 ">
            <Row>
              <Col lg={6}>
                <Card border="light">
                  <i class="fa-solid fa-money-bill-wave text-orange fs-1 px-3 pt-2"></i>
                  <Card.Body>
                    <Card.Title>Grow Your Money</Card.Title>
                    <Card.Text>
                      Increase profitability with durable, precision-engineered
                      electrical materials that reduce maintenance costs and
                      extend project life.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col lg={6}>
                <Card border="light">
                  <i class="fa-solid fa-user-ninja  text-orange fs-1 px-3 pt-2"></i>
                  <Card.Body>
                    <Card.Title>Trusted by Contractors Across India</Card.Title>
                    <Card.Text>
                      Join a growing network of contractors, developers, and
                      utility teams who rely on our products for consistent
                      performance in the field.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col lg={6}>
                <Card border="light">
                  <i class="fa-solid fa-layer-group text-orange fs-1 px-3 pt-2"></i>
                  <Card.Body>
                    <Card.Title>Custom Material Options</Card.Title>
                    <Card.Text>
                      Need customized lengths, sizes, or specifications? We
                      provide tailored manufacturing based on project
                      requirements.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col lg={6}>
                <Card border="light">
                  <i class="fa-solid fas fa-industry text-orange fs-1 px-3 pt-2"></i>
                  <Card.Body>
                    <Card.Title>Strong Supply Chain Network</Card.Title>
                    <Card.Text>
                      Pan-India supply capability ensures timely delivery even
                      in remote project locations.{" "}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col lg={6}>
                <Card border="light">
                  <i class="fa-solid fa-users text-orange fs-1 px-3 pt-2"></i>
                  <Card.Body>
                    <Card.Title>Experienced Team</Card.Title>
                    <Card.Text>
                      From manufacturing to dispatch, our experienced team
                      ensures every material meets industry standards and
                      performs reliably on-site.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col lg={6}>
                <Card border="light">
                  <Card.Body className=" text-white p-4 mx-3 rounded">
                    <Card.Title>
                      Team that <br /> Delivers great Result
                    </Card.Title>
                    <Card.Text>
                      Benefiting from nearly 25 <br /> years of collective{" "}
                      <br /> experience.
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
        {/* 
        <Row className="bgyellow">
          <Col
            sm={6}
            lg={8}
            className="p-3 d-flex align-items-center justify-content-center"
          >
            <div className=" p-3">
              <h5 className="text-yellow fw-bold m-2 p-2">
                Make Tomorrow Better Than Today.
              </h5>
              <h2 className=" text-light fw-bold m-2 p-2">
                We are providing specialised knowledge and the best
                Agri-services.
              </h2>
              <p className=" text-light m-2 p-2 text-justify">
                Every day, we have more people on planet Earth — and less
                topsoil, water, and land with which to grow food.
              </p>
              <p className=" text-light m-2 p-2 text-justify">
                Which leaves us with the question: how will we sustainably feed
                future generations of humans? Some researchers believe that
                hydroponics — a method of growing food with water, nutrients,
                and light, but no soil — could be part of the solution.
              </p>
              <Link to="/Contact" className="btn btn-success m-3">
                {" "}
                <i class="fa-solid fa-circle-arrow-right fa-beat"> </i> Explore
                All Features!
              </Link>
            </div>
          </Col>
          <Col
            sm={6}
            lg={4}
            className="p-4   d-flex align-items-center justify-content-center"
          >
            <img
              src={manimg}
              style={{ width: "100%", maxWidth: "300px", height: "auto" }}
              className="img-fluid rounded"
              alt="hydroponic farm"
            />
          </Col>
        </Row> */}
      </Container>
    </>
  );
}
export default AgreeServicess;
